import { createFileRoute } from '@tanstack/react-router'
import { trpc } from '@/main'
import { GroupLogin } from './-components/orgs/group-login'
import { GroupLoginPending } from './-components/orgs/group-login-pending'

export const Route = createFileRoute('/_app/orgs_/$orgId/users/groups/$groupId/')({
  loader: ({ context, params }) => {
    context.queryClient.prefetchQuery(trpc.orgs.getOrgAndGroups.queryOptions(params.orgId))
  },
  component: RouteComponent,
  pendingComponent: GroupLoginPending,
})

function RouteComponent() {
  const { orgId, groupId } = Route.useParams()
  return <GroupLogin orgId={orgId} groupId={groupId} />
}
